<script>
    // 봇 빌더 "이미지 에셋" 탭 — 이 봇의 통합 이미지 라이브러리(관리 뷰).
    // 챗 빌더 ScenePromptContextList 와 대칭. embedded=관리 전용(업로드·폴더·버전/롤백·이동·이름변경·삭제).
    // 봇 문맥 폴더(봇/{제목})로 랜딩하되 "전체"로 올라가 계정 전체 자산을 볼 수 있다.
    import ImagePicker from "./chat-builder/ImagePicker.svelte";
    import { botAssetFolder } from "./chat-builder/imageAssetApi";

    export let bot;
</script>

<div
    class="tw-flex tw-flex-col tw-gap-4"
    class:tw-hidden={bot.currentTab !== "imageAsset"}
>
    <div>
        <h2 class="tw-text-base tw-font-semibold tw-text-foreground sm:tw-text-lg">
            이미지 에셋
        </h2>
        <p class="tw-mt-1 tw-text-sm tw-text-muted-foreground">
            이 봇의 이미지를 폴더·버전으로 관리하세요. 콘텐츠 블록의 "라이브러리에서 선택"에서 이 자산을 그대로 불러 씁니다.
        </p>
    </div>
    <!-- 탭이 열릴 때만 마운트: 봇 제목(getBotInfo) 로드 후여야 contextFolder가 봇/{id} 대신 봇/{제목}으로 잡힌다.
         (항상 마운트하면 제목 로드 전에 폴더가 id로 굳어 업로드가 봇/{id}에 저장되는 버그) -->
    {#if bot.currentTab === "imageAsset"}
        <ImagePicker embedded contextFolder={botAssetFolder(bot)} />
    {/if}
</div>
